import { useCallback, useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import { apiUrl } from '../../config/api';

const EMPTY_CART = { cart_items: [], total_cart_value: 0 };

/** Cart contents, totals, coupons and shipping — used by the modal and checkout. */
const useCartContant = () => {
  const [cartproducts, setCartProducts] = useState(EMPTY_CART);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchCartProducts = useCallback(
    async (couponId, fastDelivery, couponCode) => {
      const userId = localStorage.getItem('user_id') || '';
      const commonId = localStorage.getItem('common_id') || '';

      setLoading(true);
      try {
        const response = await fetch(apiUrl('/api/cart/items'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            common_id: commonId,
            user_id: parseInt(userId, 10),
            coupon_id: couponId || 'null',
            coupon_code: couponCode || 'null',
            fast_delivery: fastDelivery || false,
          }),
        });
        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();
        if (!isMounted.current) return;

        // Only warn about a coupon the shopper actually typed in.
        if (couponCode && !data.valid_coupon && data.cart_items?.length > 0) {
          Swal.fire({
            icon: 'warning',
            confirmButtonColor: '#b63f23',
            title: `Coupon "${couponCode}" is not valid`,
          });
        }

        setCartProducts({ ...EMPTY_CART, ...data });
        setError(null);
      } catch {
        if (isMounted.current) setError('We could not load your cart.');
      } finally {
        if (isMounted.current) setLoading(false);
      }
    },
    []
  );

  return { cartproducts, loading, error, fetchCartProducts };
};

export default useCartContant;
